<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "./EditComponentStatic";
const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
const uiData = reactive(ui);
//config.validate = validate;

let colors = ref("000000");
onMounted(() => {
  mounted(uiData, props, config);
  colors = config.initValue;
});
function updateValue(c: any) {
  try {
    const e = c.hex;
    valueChanged(config, uiData, e);
    config.emit("seteditvalue", { value: e, field: config.column });
  } catch (e) {
    console.error(
      "Error in field '" + uiData.description + "' on valueChanged:" + e
    );
  }
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <label v-bind="props">{{ uiData.description }}</label>
        <v-color-picker
          v-model="colors"
          @input="updateValue"
          swatches-max-height="200"
          dot-size="25"
          color="warning"
          :error-messages="uiData.errorText"
          persistent-hint
        />

        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>